import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SideNavOuterToolbarModule, SideNavInnerToolbarModule, SingleCardModule } from './layouts';
import { FooterModule, ResetPasswordFormModule, CreateAccountFormModule, ChangePasswordFormModule } from './shared/components';
import { ScreenService, AppInfoService } from './shared/services';
import { DxButtonModule, DxTileViewModule } from 'devextreme-angular';
import { CoreModule } from './core/core.module';
import { AuthService } from './shared/services/auth/auth.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { SharedModule } from './shared/shared.module';
import { UnauthenticatedContentModule } from './unauthenticated-content';

import { CustomGrillaModule } from './shared/components/custom-grilla/custom-grilla.component';
import { ValidateUserModule } from './shared/components/validate-user/validate-user.component';
import { InicioModule } from './pages/inicio/inicio.module';
import { ProgressComponent } from './shared/components/mensajes';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { loadMessages, locale } from 'devextreme/localization';

// Registrar el locale español
registerLocaleData(localeEs);

// Configurar DevExtreme en español y moneda ARS
import esMessages from 'devextreme/localization/messages/es.json';
import config from 'devextreme/core/config';
loadMessages(esMessages);
locale('es-AR');
// Configuración global de moneda ARS
config({
  defaultCurrency: 'ARS'
});


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DxButtonModule,
    CoreModule,
    SideNavOuterToolbarModule,
    SideNavInnerToolbarModule,
    SingleCardModule,
    FooterModule,
    ResetPasswordFormModule,
    CreateAccountFormModule,
    ChangePasswordFormModule,
    UnauthenticatedContentModule,
    SharedModule,
    DxTileViewModule,
    CustomGrillaModule,
    ValidateUserModule,
    InicioModule
  ],
  providers: [AuthService, ScreenService, AppInfoService,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: JwtInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  },
  {
    provide: LOCALE_ID,
    useValue: 'es-AR'
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }

